var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modals-and-snackbars"},[_c('AuthModal'),_c('AuthSnackbar'),_c('LoginSuccessSnackbar'),_c('EditorSnackbar'),_c('SendEmailModal',{attrs:{"show":_vm.getEmailModalState,"header-class":_vm.emailHeaderClass,"color":_vm.emailHeaderColor},on:{"hide":_vm.hideEmailModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }